import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import ImportStatementPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/ImportStatementPage";
import AuthService from "../../../../../api/AuthService";

function ImportStatement() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { state } = useLocation();

  const handleUpload = async (uploadedFile, encoding) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("statement", uploadedFile);
      formData.append("accountId", state.accountID);
      formData.append("encoding", encoding);

      const response = await AuthService.handleAddStatementTransaction(
        formData
      );

      if(response.success) {
        setSuccess("File uploaded successfully!")
      }
      else {
        console.error(response.message)
        showAlert("Failed to upload file.", error)
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to upload file. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ImportStatementPage
      handleUpload={handleUpload}
      loading={loading}
      error={error}
      success={success}
    />
  );
}

export default ImportStatement;
